import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { cloneDeep } from 'lodash';
import { JoveProjectTypeEnum } from '../enums/common';
import { OrganizationRoles, PartnerType } from '../shared/generated';
import { getLocalTranslation } from './i18nKit';

/**
 * build the portal list / organization list which the current user can access
 * based on user roles.
 */
export var getCurrentUserPortalInfo = function getCurrentUserPortalInfo(user, roles, config) {
  var _config$hidePortalLis, _config$hidePortalLis2, _config$hidePortalLis3, _config$hidePortalLis4, _config$hidePortalLis5;

  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  var list = [];
  var cmsUrl = process.env['NX_CMS_URL'];
  var dashboardUrl = process.env['NX_DASHBOARD_URL'];
  var websiteUrl = process.env['NX_WEBSITE_URL']; // const organizationList = cloneDeep(user?.organizations || []).filter((item) => item.slug !== 'joveco') || [];

  var organizationList = cloneDeep((user === null || user === void 0 ? void 0 : user.organizations) || []);
  var partnersList = ((user === null || user === void 0 ? void 0 : user.partners) || []).map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      value: item === null || item === void 0 ? void 0 : item.id,
      label: "".concat(item.type === PartnerType.GENERAL ? 'Partner' : !!item.parent ? 'Sub-broker' : 'Broker', ": ").concat(item.name),
      href: "".concat(cmsUrl, "/").concat(item.type === PartnerType.GENERAL ? 'new-partners' : 'brokers', "/").concat(item.slug, "/portal/quotes")
    });
  });
  var needSelectPortal = false;
  organizationList.forEach(function (item) {
    item.value = item.slug;
    item.label = item.name;
  });

  if (!(config !== null && config !== void 0 && (_config$hidePortalLis = config.hidePortalListKey) !== null && _config$hidePortalLis !== void 0 && _config$hidePortalLis.includes('jove-customer')) && roles !== null && roles !== void 0 && roles.includes('jove-customer')) {
    list.push({
      value: 'jove-customer',
      label: $t('text:userPortal.customer_dashboard'),
      replaceUrl: true,
      href: "".concat(dashboardUrl, "?queryUserId=").concat(user === null || user === void 0 ? void 0 : user.id)
    });
  }

  if (!(config !== null && config !== void 0 && (_config$hidePortalLis2 = config.hidePortalListKey) !== null && _config$hidePortalLis2 !== void 0 && _config$hidePortalLis2.includes(OrganizationRoles.JOVE_ADMIN)) && roles !== null && roles !== void 0 && roles.includes(OrganizationRoles.JOVE_ADMIN)) {
    list.push({
      value: OrganizationRoles.JOVE_ADMIN,
      label: $t('text:userPortal.jove_validation_master_portal'),
      replaceUrl: true,
      href: cmsUrl
    });
  }

  if (!(config !== null && config !== void 0 && (_config$hidePortalLis3 = config.hidePortalListKey) !== null && _config$hidePortalLis3 !== void 0 && _config$hidePortalLis3.includes('partner-admin')) && roles !== null && roles !== void 0 && roles.includes('partner-admin') && partnersList.length > 0) {
    list.push({
      value: 'partner-admin',
      label: $t('text:userPortal.broker_dashboard'),
      replaceUrl: true,
      href: partnersList[0].href
    });
  }

  if (!(config !== null && config !== void 0 && (_config$hidePortalLis4 = config.hidePortalListKey) !== null && _config$hidePortalLis4 !== void 0 && _config$hidePortalLis4.includes(OrganizationRoles.ORG_ADMIN)) && roles !== null && roles !== void 0 && roles.includes(OrganizationRoles.ORG_ADMIN) && organizationList.length > 0) {
    list.push({
      value: OrganizationRoles.ORG_ADMIN,
      label: $t('text:userPortal.insurance_validation_portal'),
      replaceUrl: true,
      defaultOrgHref: "".concat(cmsUrl, "/organization/").concat(organizationList[0].slug),
      href: "".concat(cmsUrl, "/organization")
    });
  }

  if (!(config !== null && config !== void 0 && (_config$hidePortalLis5 = config.hidePortalListKey) !== null && _config$hidePortalLis5 !== void 0 && _config$hidePortalLis5.includes('community-user')) && roles !== null && roles !== void 0 && roles.includes('community-user')) {
    list.push(_objectSpread({
      value: 'community-user',
      label: $t('text:navigation.jove_community'),
      href: '/community'
    }, (config === null || config === void 0 ? void 0 : config.productSource) === JoveProjectTypeEnum.website ? {} : {
      replaceUrl: true,
      href: "".concat(websiteUrl, "/community")
    }));
  }

  needSelectPortal = list.length > 1 || (organizationList === null || organizationList === void 0 ? void 0 : organizationList.length) > 1 || (partnersList === null || partnersList === void 0 ? void 0 : partnersList.length) > 1;
  return {
    needSelectPortal: needSelectPortal,
    portalList: list,
    organizationList: organizationList,
    partnersList: partnersList
  };
};
export var judgeHaveSelectedCommunityUser = function judgeHaveSelectedCommunityUser() {
  return sessionStorage.getItem('WEBSITE_HAVE_SELECT_PORTAL');
};
export var markSelectCommunityUser = function markSelectCommunityUser(item) {
  var isSelected = (item === null || item === void 0 ? void 0 : item.value) === 'community-user';

  if (isSelected) {
    sessionStorage.setItem('WEBSITE_HAVE_SELECT_PORTAL', 'true');
  }

  return isSelected;
};
/**
 * navigate to the selected portal.
 * @param router next/router instance, used for in-app navigation
 */

export var jumpToUserPortal = function jumpToUserPortal(router, item, config) {
  if (!item) {
    return;
  }

  var url = item.href;

  var _ref = config || {},
      organizationSlug = _ref.organizationSlug,
      forceJump = _ref.forceJump;

  if (item.value === OrganizationRoles.ORG_ADMIN) {
    if (organizationSlug) {
      url += "/".concat(organizationSlug);
    } else {
      url = item.defaultOrgHref;
    }
  }

  var isExternalUrl = /^https?:\/\//.test(url || '');

  if (item.replaceUrl || isExternalUrl) {
    window.location.replace(url);
    return;
  }

  if (forceJump || ['/callback'].some(function (prefix) {
    var _router$pathname;

    return router === null || router === void 0 ? void 0 : (_router$pathname = router.pathname) === null || _router$pathname === void 0 ? void 0 : _router$pathname.startsWith(prefix);
  }) || sessionStorage.getItem('WEBSITE_HAVE_ENTER_LOGIN_CHECK')) {
    if (sessionStorage.getItem('WEBSITE_HAVE_ENTER_LOGIN_CHECK')) {
      sessionStorage.removeItem('WEBSITE_HAVE_ENTER_LOGIN_CHECK');
    }

    setTimeout(function () {
      router === null || router === void 0 ? void 0 : router.push(url);
    }, 0);
  }
};